// @ts-nocheck
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ newShipTo: ShipToModel | undefined }>;

export const dispatchSetNewContextualisedShipTo: HandlerType = props => {
    props.dispatch({
        type: "Greif/PagesReducer/RequestOrderChange/SetNewContextualisedShipTo",
        newShipTo: props.parameter.newShipTo,
    });
};

export const chain = [dispatchSetNewContextualisedShipTo];

const setNewContextualisedShipTo = createHandlerChainRunner(chain, "SetNewContextualisedShipTo");
export default setNewContextualisedShipTo;
